import { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance.js";
import Pagination from "../../common/Pagination/index.js";
import Loader from "../../common/Loader/index.js";
import { BiSolidEditAlt } from "react-icons/bi";
import { MdClose, MdDeleteForever } from "react-icons/md";
import Model from "../../common/Model/index.js";
import { LiaSearchPlusSolid } from "react-icons/lia";
import FormFields from "../../common/FormFields/index.js";
import { notify, Toast } from "../../common/Toast/index.js";
import { getEntityFields } from "../../utlis/entityConfig.js";
import { getUserMenuPermission } from "../../common/Helper/index.js";

const Owner = () => {
  const permission = getUserMenuPermission(1);
  const [isOwnerData, setIsOwnerData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedOwnerId, setSelectedOwnerId] = useState(null);
  const [formData, setFormData] = useState({
    owner_ID: 0,
    name: "",
    contactNo: "",
    email: "",
    firmName: "",
    officeAddress: "",
  });
  const userId = sessionStorage.getItem("userId");

  const fetchOwnerData = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.post(
        `Owner/GetAll?pageNumber=${currentPage}&pageSize=${pageSize}`,
        {
          pageNumber: currentPage,
          pageSize,
          owner_ID: 0,
        }
      );
      setIsOwnerData(res.data.owners);
      setFilteredData(res.data.owners);
      setTotalRecords(res.data.totalRecords);
      setTotalPages(
        res.data.owners?.length < pageSize ? currentPage : currentPage + 1
      );
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOwnerData();
  }, [currentPage]);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAddOwner = () => {
    if (!permission.isInsert) {
      notify("You don't have permission to add owners.", "error");
      return;
    }
    setFormData({
      owner_ID: "",
      name: "",
      contactNo: "",
      email: "",
      firmName: "",
      officeAddress: "",
    });
    setIsEditing(false);
    setIsModelOpen(true);
  };

  const handleEditOwner = async (id) => {
    try {
      const { data } = await axiosInstance.get(`Owner/GetById/${id}`);
      if (data) {
        setFormData({
          owner_ID: data.owner_ID || "",
          name: data.owner_Name || "",
          contactNo: data.contact_No || "",
          email: data.email_ID || "",
          firmName: data.firm_Name || "",
          officeAddress: data.office_Address || "",
        });
        setIsEditing(true);
        setIsModelOpen(true);
      }
    } catch (err) {
      notify("Error fetching owner data:", err);
    }
  };

  const handleDeleteOwner = (id) => {
    setSelectedOwnerId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await axiosInstance.delete(`Owner/Delete/${selectedOwnerId}`);
      fetchOwnerData();
      notify("Owner deleted successfully!", "error");
    } catch (err) {
      notify("Failed to delete owner!", "error");
    } finally {
      setIsDeleteModalOpen(false);
      setSelectedOwnerId(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isEditing && !permission.isInsert) return;
    if (isEditing && !permission.isUpdate) return;

    try {
      const payload = {
        Contact_No: formData.contactNo,
        Email_ID: formData.email,
        Firm_Name: formData.firmName,
        Owner_Name: formData.name,
        Office_Address: formData.officeAddress,
        Owner_ID: formData.owner_ID ? parseInt(formData.owner_ID, 10) : 0,
        Created_By: userId,
        UpdatedBy: userId,
      };

      await axiosInstance.post("Owner/SaveUpdate", payload);
      setIsModelOpen(false);
      fetchOwnerData();
      notify(
        isEditing ? "Owner updated successfully!" : "Owner added successfully!",
        "success"
      );
    } catch (err) {
      notify("Error submitting form:", "error");
    }
  };
  const fetchFilteredowner = async (query) => {
    try {
      setLoading(true);
      const res = await axiosInstance.get(
        `Owner/FilterByName?ownerName=${query}`
      );
      setFilteredData(res.data);
      setTotalRecords(res.data.length);
    } catch (err) {
      notify("Error fetching filtered data", "error");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (searchQuery.trim() === "") {
      fetchOwnerData();
    } else {
      fetchFilteredowner(searchQuery);
    }
  }, [searchQuery, currentPage]);

  const clearSearch = () => {
    setSearchQuery("");
    fetchOwnerData();
  };

  return (
    <>
      <Toast />
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5">
        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
          <div className="relative w-full sm:w-1/2 lg:w-1/3">
            <input
              type="text"
              className="w-full bg-gray-100 border border-gray-3 py-2 pl-10 pr-10 rounded-md focus:ring-1 focus:ring-primary focus:border-primary outline-none"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary">
              <LiaSearchPlusSolid className="w-5 h-5" />
            </button>
            {searchQuery && (
              <button
                onClick={clearSearch}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-danger"
              >
                <MdClose className="w-5 h-5" />
              </button>
            )}
          </div>
          {permission.isInsert && (
            <button
              className="bg-primary rounded px-4 text-white py-2"
              onClick={handleAddOwner}
            >
              + Add Owner
            </button>
          )}
        </div>
        {loading ? (
          <Loader />
        ) : permission.isView ? (
          <div className="overflow-x-auto rounded-lg">
            <table className="w-full text-sm text-left border border-gray">
              <thead className="bg-primary text-white tracking-widest text-center font-light">
                <tr>
                  <th className="border border-gray-300 px-4 py-3 whitespace-nowrap">
                    Name
                  </th>
                  <th className="border border-gray-300 px-4 py-3 whitespace-nowrap">
                    Contact
                  </th>
                  <th className="border border-gray-300 px-4 py-3 whitespace-nowrap">
                    Email
                  </th>
                  <th className="border border-gray-300 px-4 py-3 whitespace-nowrap">
                    Firm
                  </th>
                  <th className="border border-gray-300 px-4 py-3 whitespace-nowrap">
                    Address
                  </th>
                  <th
                    className={`${
                      !permission.isUpdate && !permission.isDelete
                        ? "hidden"
                        : ""
                    } border border-gray-400 px-4 py-3 whitespace-nowrap`}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                {filteredData?.length > 0 ? (
                  filteredData.map((owner) => (
                    <tr
                      key={owner.owner_ID}
                      className="border-b hover:bg-gray-50 transition cursor-pointer"
                    >
                      <td className="border border-gray-100 px-4 py-2">
                        {owner.owner_Name}
                      </td>
                      <td className="border border-gray-100 px-4 py-2">
                        {owner.contact_No}
                      </td>
                      <td className="border border-gray-100 px-4 py-2 truncate">
                        {owner.email_ID}
                      </td>
                      <td className="border border-gray-100 px-4 py-2">
                        {owner.firm_Name}
                      </td>
                      <td className="border border-gray-100 py-2 max-w-[150px]">
                        {owner.office_Address}
                      </td>
                      {(permission.isUpdate || permission.isDelete) && (
                        <td className="py-3 border border-gray-100 text-center space-x-2">
                          {permission.isDelete && (
                            <button
                              className="bg-red-100 text-red-600 hover:bg-red-200 px-2 py-1 rounded-md"
                              onClick={() => handleDeleteOwner(owner.owner_ID)}
                            >
                              <MdDeleteForever className="w-5 h-5" />
                            </button>
                          )}
                          {permission.isUpdate && (
                            <button
                              className="bg-[#e3f2fd] text-primary hover:bg-blue-200 px-2 py-1 rounded-md"
                              onClick={() => handleEditOwner(owner.owner_ID)}
                            >
                              <BiSolidEditAlt className="w-5 h-5" />
                            </button>
                          )}
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-4">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center text-red-500 text-lg py-10">
            You don't have permission to view this page.
          </div>
        )}
        <div className="flex justify-between items-center">
          <p className="text-sm text-gray-6">
            Showing {isOwnerData?.length + (currentPage - 1) * 10} of{" "}
            {totalRecords} Records
          </p>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
      <Model
        isOpen={isModelOpen}
        onClose={() => setIsModelOpen(false)}
        name={isEditing ? "Edit Owner" : "Add Owner"}
      >
        <FormFields
          onSubmit={handleSubmit}
          setIsModelOpen={setIsModelOpen}
          formData={formData}
          handleInputChange={handleInputChange}
          fields={getEntityFields("owner")}
          onClear={() => setIsModelOpen(false)}
          isEditing={isEditing}
        />
      </Model>
      <Model
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
      >
        <div className="p-4 text-center">
          <p className="text-lg font-semibold mb-4">
            Are you sure you want to delete this site?
          </p>
          <div className="flex justify-center gap-4">
            <button
              className="bg-gray-5 px-4 py-2 rounded-md"
              onClick={() => setIsDeleteModalOpen(false)}
            >
              Cancel
            </button>
            <button
              className="bg-danger text-white px-4 py-2 rounded-md"
              onClick={handleConfirmDelete}
            >
              Delete
            </button>
          </div>
        </div>
      </Model>
    </>
  );
};

export default Owner;
